export const TOGGLE_MAIN_MENU = 'global/toggleMainMenu'
export const CLEAR_STATE = 'global/clearState'
export const INIT_STATE = 'global/initState'



// WEBPACK FOOTER //
// ./src/store/global/mutations_types.js